import { render, staticRenderFns } from "./ForumPages.vue?vue&type=template&id=e07884fe&"
import script from "./ForumPages.vue?vue&type=script&lang=js&"
export * from "./ForumPages.vue?vue&type=script&lang=js&"
import style0 from "./ForumPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports